import type { BadgeVariant } from '../../components/common/StatusBadge';
import type { SpotlightStatus } from './types';

type StatusMeta = { label: string; variant: BadgeVariant };

function metaFrom(map: Record<string, StatusMeta>, status: string): StatusMeta {
  return map[status] ?? { label: prettify(status), variant: 'default' };
}

function prettify(status: string): string {
  return status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

const SPOTLIGHT_STATUS: Record<string, StatusMeta> = {
  draft: { label: 'Draft', variant: 'default' },
  published: { label: 'Published', variant: 'success' },
  archived: { label: 'Archived', variant: 'default' },
};

const EXPERIMENT_STATUS: Record<string, StatusMeta> = {
  draft: { label: 'Draft', variant: 'default' },
  approved: { label: 'Approved', variant: 'info' },
  running: { label: 'Running', variant: 'blue' },
  completed: { label: 'Completed', variant: 'success' },
  archived: { label: 'Archived', variant: 'default' },
  failed: { label: 'Failed', variant: 'error' },
};

const RUN_STATUS: Record<string, StatusMeta> = {
  pending_external_job: { label: 'Pending', variant: 'warning' },
  running: { label: 'Running', variant: 'blue' },
  completed: { label: 'Completed', variant: 'success' },
  failed: { label: 'Failed', variant: 'error' },
};

export function spotlightStatusMeta(status: string): StatusMeta {
  return metaFrom(SPOTLIGHT_STATUS, status);
}

export function experimentStatusMeta(status: string): StatusMeta {
  return metaFrom(EXPERIMENT_STATUS, status);
}

export function runStatusMeta(status: string): StatusMeta {
  return metaFrom(RUN_STATUS, status);
}

export const SPOTLIGHT_LIFECYCLE: { key: SpotlightStatus; label: string }[] = [
  { key: 'draft', label: 'Draft' },
  { key: 'published', label: 'Published' },
];
